module.exports = __webpack_public_path__ + "img/login-password-mark.200113c9.svg";